import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  VpAccordion,
  VpAccordionItem,
  VpAccordionItemHeader,
  VpAccordionItemHeaderIcon,
  VpAccordionItemHeaderLabel,
  VpAccordionItemHeaderSubline,
  VpAccordionItemPanel,
  VpLoader,
} from '@vtmn-play/react';
import { useCustomZones } from '../../hooks/useCustomZones';
import './customZoneSelection.scss';

export interface CustomZoneSelectionProps {
  customZonesIds: string[];
}

export const CustomZoneSelection = ({
  customZonesIds,
}: CustomZoneSelectionProps) => {
  const item = 'zone-panel';
  const [openPanel, setOpenPanel] = useState<string[]>([]);
  const { t } = useTranslation();

  const { data: customZonesData, isFetching } = useCustomZones(customZonesIds);

  return (
    <div
      className="custom-zone-selection-container"
      data-testid="custom-zone-selection-container"
    >
      {isFetching ? (
        <VpLoader role="marquee" aria-label="Content is loading..." />
      ) : (
        <VpAccordion
          value={openPanel}
          onChange={(e: string[]) => setOpenPanel(e)}
        >
          <VpAccordionItem value={item}>
            <VpAccordionItemHeader>
              <VpAccordionItemHeaderLabel>
                {t('sm-info.custom-zone-selection')}
              </VpAccordionItemHeaderLabel>
              <VpAccordionItemHeaderSubline>
                {`${customZonesIds.length} ${t('sm-info.selected-countries')}`}
              </VpAccordionItemHeaderSubline>
              <VpAccordionItemHeaderIcon />
            </VpAccordionItemHeader>
            <VpAccordionItemPanel>
              <div className="custom-zones-container">
                {customZonesData ? (
                  customZonesData.map((zone) => (
                    <div key={zone} aria-label="custom zone">
                      {zone}
                    </div>
                  ))
                ) : (
                  <div>{t('sm-info.missing-information')}</div>
                )}
              </div>
            </VpAccordionItemPanel>
          </VpAccordionItem>
        </VpAccordion>
      )}
    </div>
  );
};
